import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { HeaderWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { ContentH3 } from 'src/domains/layouts/shared/typography/Content.style';

interface ListHeaderPropsType {
    label: string;
    children?: string | JSX.Element;
}

export const ListHeader = observer('ListHeader', ({ label, children }: ListHeaderPropsType) => {
    return (
        <HeaderWrapper>
            <ContentH3>{label}</ContentH3>

            {children}
        </HeaderWrapper>
    );
});
